<div class="new-comers-area ptb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="new-comers-image">
                    <img src="assets/img/motivation-course/new-comers/new-comers-2.png" alt="image">
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="new-comers-content">
                    <span class="sub-title">Hakkımızda</span>
                    <h3>Learn New Skills to Go Ahead for Your Career</h3>
                    <h4>We can support student forum 24/7 for national and international students.</h4>
                    <p>Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae donec
                        velit neque auctor sit amet aliquam vel ullamcorper sit amet ligula quisque velit nisi pretium
                        ut lacinia in elementum id enim.</p>
                    <h5>A place where you can achieve your dream</h5>
                    <p>Pellentesque in ipsum id orci porta dapibus. Vestibulum ac diam sit amet quam vehicula elementum
                        sed sit amet dui. Proin eget tortor risus. Lorem ipsum dolor sit amet consectetur adipiscing
                        elit. Vestibulum ac diam sit amet quam vehicula elementum sed sit amet dui. Donec rutrum congue
                        leo eget malesuada.</p>
                    <div class="new-comers-btn">
                        <a routerLink="/about-style-1" class="default-btn">
                            <i class='bx bx-move-horizontal icon-arrow before'></i>
                            <span class="label">Read More</span>
                            <i class="bx bx-move-horizontal icon-arrow after"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>